const COOKIE_KEY = 'user-cookies'
const COOKIE_VALUE_TRUE = 'accepted'
const COOKIE_VALUE_NON_PRODUCT_ANALYTICS = 'accepted-non-pruduct-analytics'
const COOKIE_VALUE_FALSE = 'declined'

export { COOKIE_KEY, COOKIE_VALUE_TRUE, COOKIE_VALUE_NON_PRODUCT_ANALYTICS, COOKIE_VALUE_FALSE }
